/** Remove empty editor-generated links from the rendered article, never its saved content. */
(() => {
  function cleanArticleLinks(root) {
    root.querySelectorAll('.article-template__content a[href]').forEach((link) => {
      const referencedName = (link.getAttribute('aria-labelledby') || '').split(/\s+/)
        .some((id) => document.getElementById(id)?.textContent.trim());
      const hasName = link.textContent.trim() || link.getAttribute('aria-label')?.trim()
        || link.getAttribute('title')?.trim() || referencedName;
      // Preserve image/icon links and fragment destinations. Only discard empty editor artifacts.
      const hasMedia = link.querySelector('img, svg, picture, video, audio, canvas, iframe, object, [role="img"]');
      const namedChild = [...link.querySelectorAll('[aria-label], [aria-labelledby], [title]')]
        .some((child) => child.getAttribute('aria-label')?.trim() || child.getAttribute('title')?.trim()
          || (child.getAttribute('aria-labelledby') || '').split(/\s+/)
            .some((id) => document.getElementById(id)?.textContent.trim()));
      if (!hasName && !namedChild && !hasMedia && !link.hasAttribute('id') && !link.hasAttribute('name')) link.replaceWith(...link.childNodes);
    });
  }

  cleanArticleLinks(document);
  document.addEventListener('shopify:section:load', (event) => cleanArticleLinks(event.target));
})();
